import axios from "axios";

const apiSimulator = axios.create({
  // baseURL: "https://thingproxy.freeboard.io/fetch/https://nutrire.ind.br/api",
  baseURL: "https://nutrire.ind.br/api",
  //   baseURL: "https://jobs.flowww.digital/nutrire/public_html/api",
});

// Interceptor para adicionar o cabeçalho `Language`
apiSimulator.interceptors.request.use(
  (config) => {
    const language = localStorage.getItem("language");

    if (language) {
      //   config.headers.Language = language;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiSimulator;
